export default __webpack_public_path__ + "images/img-closed.7d759e6298cb3836f818f6f239d35bdb.png";